import { render, staticRenderFns } from "./ConsentDialog.vue?vue&type=template&id=6bdf3453"
import script from "./ConsentDialog.vue?vue&type=script&lang=js"
export * from "./ConsentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports